import { StylesConfig } from 'react-select';

export type IOption = {
  value?: string | number,
  label?: string
  start?: string | number,
  end?: string | number,
};
const primary = '#1C376B';

export const style1: StylesConfig<IOption, boolean> = {
  container: (provided: any) => ({ ...provided }),
  control: (provided: any) => ({
    ...provided,
    minHeight: 46,
    borderRadius: 4,
    backgroundColor: 'transparent',
    boxShadow: '0 0 0 1px transparent',
    borderColor: 'transparent',
    '&:hover': {
      borderColor: primary,
    },
  }),
  placeholder: (provided: any) => ({ ...provided, fontSize: '16px' }),
  valueContainer: (provided: any) => ({ ...provided }),
  singleValue: (provided: any) => ({ ...provided, fontSize: '16px', color: 'white' }),
  multiValue: (provided: any) => ({
    ...provided, fontSize: '12px', backgroundColor: primary, color: 'white', padding: 2, borderRadius: 6,
  }),
  multiValueLabel: (provided: any) => ({ ...provided, color: 'white', fontSize: '12px' }),
  multiValueRemove: (provided: any) => ({ ...provided, borderRadius: 6 }),
  input: (provided: any) => ({
    ...provided,
    '&:focus': {
      boxShadow: '',
    },
  }),
  dropdownIndicator: (provided: any) => ({ ...provided }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '12px',
    backgroundColor: state.isSelected ? primary : '',
    color: !state.isSelected ? primary : 'white',
    '&:hover': {
      backgroundColor: primary,
      color: 'white',
    },
  }),
  clearIndicator: (provided: any) => ({ ...provided }),
  indicatorSeparator: () => ({ display: 'none' }),
};

export const style2: StylesConfig<IOption, boolean> = {
  container: (provided: any) => ({ ...provided }),
  control: (provided, state) => ({
    ...provided,
    minHeight: 50,
    borderRadius: 9,
    backgroundColor: '#FFFFFF',
    boxShadow: '0 0 0 1px transparent',
    borderColor: 'transparent',
    fontSize: '16px',
    fontFamily: 'Montserrat-SemiBold',
    '&:hover': {
      borderColor: state.isFocused ? primary : '',
    },
  }),
  placeholder: (provided: any) => ({ ...provided, fontSize: '16px' }),
  valueContainer: (provided: any) => ({ ...provided }),
  singleValue: (provided: any) => ({ ...provided, fontSize: '16px' }),
  multiValue: (provided: any) => ({
    ...provided, fontSize: '16px', backgroundColor: primary, color: 'white', padding: 5, borderRadius: 6,
  }),
  multiValueLabel: (provided: any) => ({ ...provided, color: 'white', fontSize: '16px' }),
  multiValueRemove: (provided: any) => ({ ...provided }),
  input: (provided: any) => ({
    ...provided,
    '&:focus': {
      boxShadow: '',
    },
  }),
  dropdownIndicator: (provided: any) => ({ ...provided }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '12px',
    backgroundColor: state.isSelected ? primary : '',
    color: !state.isSelected ? primary : '',
    '&:hover': {
      backgroundColor: primary,
      color: 'white',
    },
  }),
  clearIndicator: (provided: any) => ({ ...provided }),
  indicatorSeparator: () => ({ display: 'none' }),
};
